<!-- @format -->

<ng-container *transloco="let t">
  <fudis-grid [rowGap]="'xs'" [classes]="'fudis-mt-xs'">
    @if (selectionUIState() === "ACTIVE") {
      <div role="heading" class="fudis-heading__xs" [attr.aria-level]="headingLevel()">
        {{ t("PLAN_EDIT.SELECTION_MODAL.ANY_MODULE_RULE.TITLE") }}
      </div>
      <fudis-select
        data-cy="plan-structure-any-module-rule-search"
        [size]="'lg'"
        [placeholder]="t('PLAN_EDIT.SELECTION_MODAL.SEARCH_PLACEHOLDER')"
        [label]="t('PLAN_EDIT.SELECTION_MODAL.ANY_MODULE_RULE.SEARCH_MODULES_LABEL')"
        [control]="moduleSelectControl"
        [variant]="'autocompleteType'"
        [helpText]="t('PLAN_EDIT.SELECTION_MODAL.SEARCH_HELP_TEXT')"
        [selectionClearButton]="true"
        (selectionUpdate)="updateSelected($event)"
        (filterTextUpdate)="searchTextUpdateSubject.next($event)">
        <ng-template fudisSelectOptions>
          @if (searchResults | async; as options) {
            @for (option of options; track option) {
              <fudis-select-option [data]="option" />
            }
          }
        </ng-template>
      </fudis-select>
    } @else {
      <fudis-body-text>
        {{ t("PLAN_EDIT.SELECTION_MODAL.ANY_MODULE_OR_COURSE_UNIT_TITLE") }}
      </fudis-body-text>
    }
    @for (studyModule of studyModules(); track studyModule.id) {
      <div class="sis-mb-sm sis-pr-sm">
        <sis-plan-structure-study-module-box
          [module]="studyModule"
          [headingLevel]="4"
          [action]="'select-to-plan'"
          [selected]="isInPlan(studyModule)"
          (actionChange)="handleStudyModuleSelectToggle(studyModule)">
        </sis-plan-structure-study-module-box>
      </div>
    }
  </fudis-grid>
</ng-container>
